<script setup>
import DialogDrawer from '@js/components/dialogs/DialogDrawer.vue';
import EditorField from '@js/components/fields/EditorField.vue';
import FormColumn from '@js/components/forms/FormColumn.vue';
import FormContent from '@js/components/forms/FormContent.vue';
import FormFooter from '@js/components/forms/FormFooter.vue';
import FormRoot from '@js/components/forms/FormRoot.vue';
import { useRoute } from '@js/utils/route';
import { reactive, ref } from 'vue';
import { object, string } from 'yup';

const { server, tenant, callback } = defineProps({
    server: {
        type: Object,
        required: true,
    },
    tenant: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

const isSubmitting = ref(false);

const isOpen = ref(false);

const form = reactive({
    additionalInformation: tenant.additionalInformation,
});

const validationSchema = object({
    additionalInformation: string().nullable(),
});

function submit() {
    isSubmitting.value = true;

    axios
        .post(
            route(
                'front.projectManagement.dev.postTenantHasServerAdditionalInformation',
                {
                    server: server.id,
                    tenant: tenant.id,
                },
            ),
            {
                additionalInformation: form.additionalInformation,
            },
        )
        .then(() => {
            isOpen.value = false;

            if (callback) {
                callback();
            }
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            isSubmitting.value = false;
        });
}
</script>

<template>
    <DialogDrawer v-model="isOpen" size="extra-large">
        <template #trigger>
            <slot name="trigger" />
        </template>

        <template #title> Mettre à jour </template>

        <template #full-content>
            <FormRoot
                :validation-schema="validationSchema"
                :submit="submit"
                v-slot="{ errors }"
            >
                <FormColumn>
                    <FormContent>
                        <EditorField
                            v-model="form.additionalInformation"
                            label="Informations complémentaires"
                            field-name="additionalInformation"
                            field-id="additionalInformation"
                        />
                    </FormContent>
                </FormColumn>

                <FormFooter
                    :is-submitting="isSubmitting"
                    :errors="errors"
                    without-back-button
                />
            </FormRoot>
        </template>
    </DialogDrawer>
</template>
